<!--
  @Description: 登录页
  @Author: wang.y 
  @Date: 2022-03-04 
-->
<template>
  <div></div>
</template>
<script>
import Cookies from 'js-cookie'
export default {
  components: {},
  created() {},
  mounted() {
    window.addEventListener("message", this.handleCellBack, false)
    window.parent.postMessage({ mountedStatus: 'success' },'*')
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleCellBack, false)
  },
  data() {
    return {
      path_type: '',
      current_path: '',
      target_path: ''
    }
  },
  computed: {
  },
  methods: {
    handleCellBack(event) {
      if (event.data.loginStatus == 'success') {
        console.log('login status')
        Cookies.set('user_key', event.data.user_key)
        Cookies.set('timestamp_left', event.data.timestamp_left)
        Cookies.set('timestamp_right', event.data.timestamp_right)
      } else if (event.data.loginStatus == 'quit') {
        console.log('quit login')
        window.localStorage.removeItem('show_scientific')
        Cookies.remove('user_key')
        Cookies.remove('timestamp_left')
        Cookies.remove('timestamp_right')
      } else if (event.data.setUUID == 'success') {
        console.log('set local uuid success', event.data.uuid)
        Cookies.set('uuid', event.data.uuid)
      }
    }
  }
}
</script>
<style lang="stylus" scoped></style>